import {AwsrdsClusterTarget, getByOrgIdTargetsAndAccountIdRegionRdsCluster} from "../../api/api";
import {ITargetSetEditActions} from "../../pages/EditTargetSetPage";
import {useContext} from "react";
import {OrgContext} from "../../services/OrgContext";
import {useAuthQuery} from "../../api/apiCall";
import {Alert, Container, Header, SpaceBetween, TokenGroup} from "@cloudscape-design/components";
import {describeTagFilters} from "../../utilities/targetSets";
import {GenericSelectByTagOrIdTable} from "./GenericSelectByTagOrIdTable";
import {ErrorBox} from "../ErrorBox";
import {retryText} from "../../utilities/utils";

export function RDSClusterTargets(props: {
    accountId: string,
    region: string,
    targets: AwsrdsClusterTarget[],
    actions: ITargetSetEditActions,
}) {
    const orgContext = useContext(OrgContext);
    const {
        isPending,
        data,
        isError,
        error,
        failureCount
    } = useAuthQuery(getByOrgIdTargetsAndAccountIdRegionRdsCluster, props.region, orgContext.Organization!.id!, props.accountId, {})

    return <SpaceBetween size={"m"}>
        <Container header={<Header variant={"h3"}>Selected RDS Clusters</Header>}>
            <TokenGroup
                onDismiss={x => props.actions.removeTarget(props.targets[x.detail.itemIndex])}
                items={props.targets.map(t => ({
                    label: !!t.clusterId ? `Cluster` : "Tag Filter",
                    description: !!t.clusterId
                        ? `Specific cluster with ARN ${t.clusterId}`
                        : `Any cluster that matches specified tags`,
                    iconName: !!t.clusterId ? "heart": "expand",
                    tags: describeTagFilters(t.tagFilters ?? [])
                }))}
            />
        </Container>
        {!isError
            ? <GenericSelectByTagOrIdTable
                data={data ?? []}
                targets={props.targets}
                targetIdentifier={"clusterId"}
                targetIdentifierName={"Cluster ARN"}
                actions={props.actions}
                table={{
                    loading: isPending,
                    loadingText: `Retrieving RDS Clusters... ${retryText(failureCount)}`,
                    columnDefinitions: [
                        {
                            id: "desc",
                            header: "Description",
                            cell: item => item.detail!.description
                        }
                    ]
                }} />
            : <ErrorBox attempted={"List RDS Clusters"} error={error} />
        }
    </SpaceBetween>
}